var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOndemandClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16847 18C2.97086 18 2 17.0291 2 15.8315H0C0 18.1337 1.86629 20 4.16847 20V18ZM23.6069 18H4.16847V20H23.6069V18ZM25.7754 15.8315C25.7754 17.0291 24.8045 18 23.6069 18V20C25.9091 20 27.7754 18.1337 27.7754 15.8315H25.7754ZM25.7754 4.16847V15.8315H27.7754V4.16847H25.7754ZM23.6069 2C24.8045 2 25.7754 2.97086 25.7754 4.16847H27.7754C27.7754 1.86629 25.9091 0 23.6069 0V2ZM4.16847 2H23.6069V0H4.16847V2ZM2 4.16847C2 2.97086 2.97086 2 4.16847 2V0C1.86629 0 0 1.86629 0 4.16847H2ZM2 15.8315V4.16847H0V15.8315H2Z",
    fill: "#7468DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1082 9.82365C11.1082 8.80533 11.1079 7.787 11.1087 6.76873C11.1087 6.66353 11.1066 6.55706 11.1202 6.45339C11.1681 6.08835 11.4044 5.95359 11.7078 6.13263C12.2358 6.44412 12.7568 6.76905 13.2803 7.08918C14.5423 7.86111 15.8041 8.63356 17.066 9.40585C17.1018 9.42778 17.1382 9.44897 17.1727 9.47305C17.5127 9.71065 17.5113 10.0057 17.1589 10.2253C16.4593 10.661 15.7557 11.0891 15.053 11.5191C13.9847 12.1728 12.9159 12.8258 11.8469 13.4781C11.7682 13.5262 11.6891 13.5779 11.6039 13.6087C11.386 13.6876 11.1993 13.5851 11.145 13.3489C11.116 13.2227 11.1101 13.0883 11.1097 12.9576C11.1071 11.913 11.1082 10.8683 11.1082 9.82365Z",
    fill: "#7468DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOndemandClass);
export default __webpack_public_path__ + "static/media/ondemandClass.accf32750ddc3747873d5dfb0839f928.svg";
export { ForwardRef as ReactComponent };